import React from 'react'
import styled from 'styled-components'
import bannerImg from 'ASSETS/png/banner.png'
import { reportTea } from 'UTILS/tea'

const Footer = () => {
  return (
    <>
      <BannerContainer>
        <BannerTitle>联系我们</BannerTitle>
        <BannerContent>
          想了解 veImageX
          为您带来的更多价值，请留下您的联系方式，我们的咨询顾问将结合您的业务为您做详细介绍
        </BannerContent>
        <BannerBtn
          onClick={() => {
            reportTea('click_contact')
            window.open('https://www.volcengine.cn/contact/product?t=veImageXlite')
          }}
        >
          立即咨询
        </BannerBtn>
      </BannerContainer>
      <Foot>
        <div>版权所有 © 北京火山引擎科技有限公司 2020 版权所有</div>
        <div>京公网安备 11010802032137号 | 京ICP备20018813号-2</div>
      </Foot>
    </>
  )
}

export default Footer

const BannerContainer = styled.div`
  background-image: url(${bannerImg});
  height: 256px;
  width: 100%;
  background-position: center;
  background-size: auto 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`

const BannerTitle = styled.div`
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  color: #ffffff;
  margin-top: 40px;
`

const BannerContent = styled.div`
  width: 279px;
  height: 66px;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  opacity: 0.8;
  margin-top: 16px;
  margin-bottom: 32px;
`

const BannerBtn = styled.div`
  width: 136px;
  height: 34px;
  background: #ffffff;
  border-radius: 4px;
  font-size: 14px;
  line-height: 22px;
  color: #3370ff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
`

const Foot = styled.div`
  padding: 20px 0 24px 0;
  height: 76px;
  width: 100%;
  box-sizing: border-box;
  font-size: 10px;
  line-height: 14px;
  letter-spacing: 0.25px;
  color: #4e5969;
  mix-blend-mode: normal;
  opacity: 0.4;
  white-space: pre-line;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`
